/* ============================================================
   VITAE - Quiz
   Fichier : assets/vitae-quiz.js

   - Navigation
   - Reponses
   - Score
   - Personnalisation
   - Klaviyo
   - Animations
   - Resultats
   ============================================================ */

(function () {
  'use strict';

  if (window.__vitQuizInit) return;

  var overlay = document.getElementById('vitQuiz');
  if (!overlay) return;

  window.__vitQuizInit = true;


  /* =========================================================
     CONFIG
     ========================================================= */

  var URL_PRODUIT =
    '/products/extrait-dail-vieilli-24-mois-100-inodore';

  var TOTAL_Q = 9;


  /* =========================================================
     ELEMENTS
     ========================================================= */

  function byId(id) {
    return document.getElementById(id);
  }

  var closeBtn = byId('vitQuizClose');
  var progWrap = byId('vitProgWrap');
  var progTrack = byId('vitProgTrack');
  var progFill = byId('vitProgFill');
  var stepNum = byId('vitStepNum');
  var stepTot = byId('vitStepTotal');
  var form = byId('vitQuizForm');
  var resCta = byId('vitResCta');

  var steps =
    Array.prototype.slice.call(
      overlay.querySelectorAll('.vit-quiz-step')
    );

  if (!steps.length) return;

  if (stepTot) {
    stepTot.textContent = TOTAL_Q;
  }

  if (resCta) {
    resCta.href = URL_PRODUIT;
  }


  /* =========================================================
     ETAT
     ========================================================= */

  var idx = 0;
  var answers = {};
  var score = 0;

  var autoTimer = null;
  var scoreToken = 0;
  var genToken = 0;
  var loadToken = 0;

  var reducedMotion =
    !!(
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    );


  /* =========================================================
     ETAT ACCESSIBLE DES CHOIX
     ========================================================= */

  var choices =
    overlay.querySelectorAll(
      '.vit-quiz-opt,' +
      '.vit-quiz-tile,' +
      '.vit-quiz-circle'
    );

  Array.prototype.forEach.call(
    choices,
    function (button) {
      button.setAttribute(
        'aria-pressed',
        button.classList.contains('is-sel')
          ? 'true'
          : 'false'
      );
    }
  );


  /* =========================================================
     PROGRESSION
     ========================================================= */

  function setProgress(i) {
    var n =
      Math.min(
        i + 1,
        TOTAL_Q
      );

    var pct =
      Math.max(
        4,
        Math.min(
          100,
          Math.round(
            n / TOTAL_Q * 100
          )
        )
      );

    if (stepNum) {
      stepNum.textContent = n;
    }

    if (progFill) {
      progFill.style.width =
        pct + '%';
    }

    if (progTrack) {
      progTrack.setAttribute(
        'aria-valuenow',
        String(n)
      );
    }
  }


  /* =========================================================
     CHANGEMENT D ETAPE
     ========================================================= */

  function show(i) {
    if (
      i < 0 ||
      i >= steps.length
    ) {
      return;
    }

    clearTimeout(autoTimer);

    steps.forEach(
      function (step, index) {
        var active =
          index === i;

        step.classList.toggle(
          'is-active',
          active
        );

        step.setAttribute(
          'aria-hidden',
          active
            ? 'false'
            : 'true'
        );
      }
    );

    idx = i;

    var isQuestion =
      i < TOTAL_Q;

    if (progWrap) {
      progWrap.style.display =
        isQuestion
          ? 'flex'
          : 'none';
    }

    if (isQuestion) {
      setProgress(i);
    }

    var currentStep =
      steps[i];

    var stepNumber =
      currentStep
        ? currentStep.getAttribute(
            'data-step'
          )
        : '';

    overlay.classList.toggle(
      'on-results',
      stepNumber === '13'
    );

    if (stepNumber === '11') {
      animateScore();
    }

    if (stepNumber === '12') {
      animateGenButton();
    }

    overlay.scrollTop = 0;
  }


  function next() {
    if (
      idx <
      steps.length - 1
    ) {
      show(idx + 1);
    }
  }


  function back() {
    if (idx > 0) {
      show(idx - 1);
    }
  }


  /* =========================================================
     CHOIX SIMPLE
     ========================================================= */

  function isSingleChoice(button) {
    return button.matches(
      '.vit-quiz-stack .vit-quiz-opt,' +
      '.vit-quiz-iconlist .vit-quiz-opt-icon,' +
      '.vit-quiz-circles .vit-quiz-circle,' +
      '.vit-quiz-row .vit-quiz-opt'
    );
  }


  function selectSingle(button) {
    var group =
      button.closest(
        '[data-field]'
      );

    if (!group) return;

    Array.prototype.forEach.call(
      group.querySelectorAll('.is-sel'),
      function (item) {
        item.classList.remove('is-sel');

        item.setAttribute(
          'aria-pressed',
          'false'
        );
      }
    );

    answers[
      group.getAttribute('data-field')
    ] =
      button.getAttribute('data-value');

    button.classList.add('is-sel');

    button.setAttribute(
      'aria-pressed',
      'true'
    );

    var step =
      button.closest(
        '.vit-quiz-step'
      );

    var continueButton =
      step
        ? step.querySelector(
            '[data-continue]'
          )
        : null;

    if (continueButton) {
      var groups =
        Array.prototype.slice.call(
          step.querySelectorAll(
            '[data-field]'
          )
        );

      continueButton.disabled =
        !groups.every(
          function (item) {
            return !!item.querySelector(
              '.is-sel'
            );
          }
        );

    } else {
      clearTimeout(autoTimer);

      autoTimer =
        setTimeout(
          next,
          reducedMotion
            ? 0
            : 200
        );
    }
  }


  /* =========================================================
     CHOIX MULTIPLE
     ========================================================= */

  function selectMulti(button) {
    var group =
      button.closest(
        '[data-field]'
      );

    if (!group) return;

    button.classList.toggle(
      'is-sel'
    );

    button.setAttribute(
      'aria-pressed',
      button.classList.contains('is-sel')
        ? 'true'
        : 'false'
    );

    var selected =
      Array.prototype.slice.call(
        group.querySelectorAll(
          '.is-sel'
        )
      );

    var values =
      selected.map(
        function (item) {
          return item.getAttribute(
            'data-value'
          );
        }
      );

    answers[
      group.getAttribute('data-field')
    ] =
      values;

    var step =
      button.closest(
        '.vit-quiz-step'
      );

    var continueButton =
      step
        ? step.querySelector(
            '[data-continue]'
          )
        : null;

    if (continueButton) {
      continueButton.disabled =
        values.length === 0;
    }
  }


  /* =========================================================
     UN SEUL LISTENER POUR LES BOUTONS
     ========================================================= */

  overlay.addEventListener(
    'click',
    function (event) {
      var button =
        event.target &&
        event.target.closest
          ? event.target.closest('button')
          : null;

      if (
        !button ||
        !overlay.contains(button)
      ) {
        return;
      }

      if (
        button.hasAttribute(
          'data-back'
        )
      ) {
        back();
        return;
      }

      if (
        button.hasAttribute(
          'data-continue'
        )
      ) {
        if (!button.disabled) {
          next();
        }

        return;
      }

      if (
        button.classList.contains(
          'vit-quiz-tile'
        ) &&
        button.closest(
          '[data-multi="true"]'
        )
      ) {
        selectMulti(button);
        return;
      }

      if (
        isSingleChoice(button)
      ) {
        selectSingle(button);
      }
    }
  );


  /* =========================================================
     SCORE
     ========================================================= */

  function computeScore() {
    var value = 20;

    var experience = {
      'Gelules de pharmacie': 22,
      'Ail cru ou cuisine': 18,
      'Autre forme': 12,
      'Jamais': 6
    };

    value +=
      experience[
        answers.experience
      ] || 0;

    var weights = {
      "L'odeur": 9,
      "L'haleine": 9,
      'Les remontees': 8,
      'Aucun effet ressenti': 6,
      'Le doute sur le dosage': 5,
      "L'oubli": 4,
      'Le prix': 2,
      'Rien': 0
    };

    (
      answers.freins || []
    ).forEach(
      function (frein) {
        value +=
          weights[frein] || 0;
      }
    );

    var durations = {
      'Moins de 2 semaines': 14,
      'Environ 1 mois': 9,
      '2 a 3 mois': 4,
      'Plus de 3 mois': 1
    };

    value +=
      durations[
        answers.duree
      ] || 0;

    if (
      answers.moment ===
      "Pas d'habitude fixe"
    ) {
      value += 6;
    }

    return Math.max(
      38,
      Math.min(
        92,
        value
      )
    );
  }


  /* =========================================================
     ANIMATION SCORE
     ========================================================= */

  function animateScore() {
    var token =
      ++scoreToken;

    var num =
      byId('vitScoreNum');

    var bar =
      byId('vitScoreBar');

    var ref =
      byId('vitScoreRef');

    var delta =
      byId('vitScoreDelta');

    if (
      !num ||
      !bar
    ) {
      return;
    }

    bar.style.setProperty(
      'height',
      '0%',
      'important'
    );

    if (ref) {
      ref.style.setProperty(
        'height',
        '0%',
        'important'
      );
    }

    num.textContent = '0%';

    if (delta) {
      delta.innerHTML =
        '<strong>+' +
        (score - 5) +
        '%</strong> d\u2019inconfort par rapport \u00e0 un extrait vieilli inodore';
    }

    if (reducedMotion) {
      bar.style.setProperty(
        'height',
        score + '%',
        'important'
      );

      if (ref) {
        ref.style.setProperty(
          'height',
          '5%',
          'important'
        );
      }

      num.textContent =
        score + '%';

      return;
    }

    void bar.offsetHeight;

    requestAnimationFrame(
      function () {
        requestAnimationFrame(
          function () {
            if (
              token !== scoreToken
            ) {
              return;
            }

            bar.style.setProperty(
              'height',
              score + '%',
              'important'
            );

            if (ref) {
              ref.style.setProperty(
                'height',
                '5%',
                'important'
              );
            }

            var start = null;
            var duration = 1200;

            function tick(time) {
              if (
                token !== scoreToken
              ) {
                return;
              }

              if (!start) {
                start = time;
              }

              var progress =
                Math.min(
                  (time - start) /
                  duration,
                  1
                );

              var eased =
                1 -
                Math.pow(
                  1 - progress,
                  3
                );

              num.textContent =
                Math.round(
                  eased *
                  score
                ) + '%';

              if (
                progress < 1
              ) {
                requestAnimationFrame(
                  tick
                );
              } else {
                num.textContent =
                  score + '%';
              }
            }

            requestAnimationFrame(
              tick
            );
          }
        );
      }
    );
  }


  /* =========================================================
     BOUTON PREPARATION
     ========================================================= */

  function animateGenButton() {
    var button =
      byId('vitBtnGen');

    var text =
      byId('vitBtnGenText');

    var progress =
      byId('vitBtnGenProg');

    if (
      !button ||
      button.classList.contains(
        'is-ready'
      )
    ) {
      return;
    }

    var token =
      ++genToken;

    if (reducedMotion) {
      button.classList.add(
        'is-ready'
      );

      button.disabled = false;

      if (text) {
        text.textContent =
          'Voir ma recommandation';
      }

      if (progress) {
        progress.style.width =
          '100%';

        progress.style.opacity =
          '0';
      }

      return;
    }

    var start = null;
    var duration = 5000;

    function tick(time) {
      if (
        token !== genToken
      ) {
        return;
      }

      if (!start) {
        start = time;
      }

      var pct =
        Math.min(
          (time - start) /
          duration,
          1
        );

      if (progress) {
        progress.style.width =
          pct * 100 + '%';
      }

      if (pct < 1) {
        requestAnimationFrame(
          tick
        );

      } else {
        button.classList.add(
          'is-ready'
        );

        button.disabled = false;

        if (text) {
          text.textContent =
            'Voir ma recommandation';
        }

        if (progress) {
          progress.style.opacity =
            '0';
        }
      }
    }

    requestAnimationFrame(tick);
  }


  /* =========================================================
     PERSONNALISATION
     ========================================================= */

  var SUB_PAR_FREIN = {
    "L'odeur":
      "L\u2019odeur est la raison num\u00e9ro un d\u2019abandon d\u2019une cure d\u2019ail. Voici ce qu\u2019elle indique.",

    "L'haleine":
      "L\u2019haleine est le sympt\u00f4me le plus visible d\u2019un ail non trait\u00e9. Voici ce qu\u2019elle indique.",

    'Les remontees':
      "Les remont\u00e9es viennent d\u2019une mol\u00e9cule pr\u00e9cise, et elles sont \u00e9vitables.",

    'Aucun effet ressenti':
      "Ne rien ressentir sur une cure trop courte ou mal dos\u00e9e est la r\u00e8gle, pas l\u2019exception.",

    'Le doute sur le dosage':
      "Le doute sur le dosage est l\u00e9gitime : la plupart des gélules ne sont pas standardisées.",

    "L'oubli":
      "L\u2019oubli n\u2019est pas un manque de volont\u00e9, c\u2019est un probl\u00e8me de rituel.",

    'Le prix':
      "Le prix se juge au co\u00fbt par jour d\u2019une cure termin\u00e9e, pas au prix de la bo\u00eete.",

    'Rien':
      "Vous n\u2019avez rien \u00e0 reprocher \u00e0 votre cure pr\u00e9c\u00e9dente. Voyons ce qui peut encore changer."
  };


  var LIGNE_PAR_FREIN = {
    "L'odeur":
      "Vous avez cit\u00e9 <strong>l\u2019odeur</strong>, signe direct d\u2019un ail encore charg\u00e9 en allicine",

    "L'haleine":
      "Vous avez cit\u00e9 <strong>l\u2019haleine</strong>, le sympt\u00f4me le plus social d\u2019un ail non vieilli",

    'Les remontees':
      "Vous avez cit\u00e9 <strong>les remont\u00e9es</strong>, provoqu\u00e9es par l\u2019allicine de l\u2019ail cru ou s\u00e9ch\u00e9",

    'Aucun effet ressenti':
      "Vous avez cit\u00e9 <strong>l\u2019absence d\u2019effet</strong>, ce qui arrive quand la cure s\u2019arr\u00eate avant la fen\u00eatre utile",

    'Le doute sur le dosage':
      "Vous avez cit\u00e9 <strong>le dosage flou</strong>, exactement ce que la standardisation r\u00e8gle",

    "L'oubli":
      "Vous avez cit\u00e9 <strong>l\u2019oubli</strong>, ce qui se corrige avec un rituel fixe, pas avec de la volont\u00e9",

    'Le prix':
      "Vous avez cit\u00e9 <strong>le prix</strong>, qui se juge au co\u00fbt d\u2019une cure men\u00e9e jusqu\u2019au bout",

    'Rien':
      "Rien ne vous a g\u00ean\u00e9 jusqu\u2019ici, c\u2019est une bonne base de d\u00e9part"
  };


  var LIGNE_DUREE = {
    'Moins de 2 semaines':
      "Vos cures durent <strong>moins de deux semaines</strong>, bien avant que quoi que ce soit puisse se juger",

    'Environ 1 mois':
      "Vos cures durent <strong>environ un mois</strong>, soit le tiers de la dur\u00e9e recommand\u00e9e",

    '2 a 3 mois':
      "Vous tenez <strong>deux \u00e0 trois mois</strong>, ce qui vous place d\u00e9j\u00e0 au-dessus de la moyenne",

    'Plus de 3 mois':
      "Vous tenez <strong>plus de trois mois</strong>, la r\u00e9gularit\u00e9 n\u2019est clairement pas votre probl\u00e8me"
  };


  var DEFAULT_FIX =
    'La solution : un extrait vieilli 24 mois, standardisé en S-allyl cystéine, inodore, pris sur 90 jours sans interruption';


  function dateFin() {
    var date =
      new Date();

    date.setDate(
      date.getDate() + 90
    );

    try {
      return new Intl.DateTimeFormat(
        'fr-FR',
        {
          day: 'numeric',
          month: 'long'
        }
      ).format(date);

    } catch (error) {
      var months = [
        'janvier',
        'février',
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        'août',
        'septembre',
        'octobre',
        'novembre',
        'décembre'
      ];

      return (
        date.getDate() +
        ' ' +
        months[
          date.getMonth()
        ]
      );
    }
  }


  function personalize() {
    var frein =
      answers.freins &&
      answers.freins.length
        ? answers.freins[0]
        : null;

    var head =
      byId('vitResHead');

    if (
      head &&
      answers.firstName
    ) {
      head.textContent =
        answers.firstName +
        ', voici votre cure recommandée';
    }


    var scoreSub =
      byId('vitScoreSub');

    if (
      scoreSub &&
      frein &&
      SUB_PAR_FREIN[frein]
    ) {
      scoreSub.textContent =
        SUB_PAR_FREIN[frein];
    }


    var scoreHead =
      byId('vitScoreHead');

    if (
      scoreHead &&
      answers.firstName
    ) {
      scoreHead.textContent =
        answers.firstName +
        ', vos réponses expliquent beaucoup de choses.';
    }


    var dateEl =
      byId('vitResDate');

    if (dateEl) {
      dateEl.textContent =
        dateFin();
    }


    var d1 =
      byId('vitDiag1');

    if (d1) {
      var experienceText = {
        'Gelules de pharmacie':
          "Vous avez d\u00e9j\u00e0 pris de <strong>l\u2019ail en g\u00e9lules</strong>, c\u2019est-\u00e0-dire de la poudre s\u00e9ch\u00e9e, non standardis\u00e9e",

        'Ail cru ou cuisine':
          "Vous passez par <strong>l\u2019ail cru ou la cuisine</strong>, o\u00f9 la quantit\u00e9 utile est impossible \u00e0 atteindre sans l\u2019odeur",

        'Autre forme':
          "Vous avez essay\u00e9 <strong>une autre forme d\u2019ail</strong>, sans que le probl\u00e8me de fond soit r\u00e9gl\u00e9",

        'Jamais':
          "Vous n\u2019avez <strong>jamais pris d\u2019ail en compl\u00e9ment</strong>, vous partez donc sans mauvaise habitude"
      };

      var d1Text =
        d1.querySelector('span');

      if (d1Text) {
        d1Text.innerHTML =
          experienceText[
            answers.experience
          ] ||
          experienceText.Jamais;
      }
    }


    var d2 =
      byId('vitDiag2');

    if (
      d2 &&
      frein
    ) {
      var d2Text =
        d2.querySelector('span');

      if (d2Text) {
        d2Text.innerHTML =
          LIGNE_PAR_FREIN[
            frein
          ] ||
          LIGNE_PAR_FREIN.Rien;
      }
    }


    var d3 =
      byId('vitDiag3');

    if (
      d3 &&
      answers.duree
    ) {
      var d3Text =
        d3.querySelector('span');

      if (d3Text) {
        d3Text.innerHTML =
          LIGNE_DUREE[
            answers.duree
          ] ||
          LIGNE_DUREE[
            'Environ 1 mois'
          ];
      }
    }


    var fix =
      byId('vitDiagFix');

    if (fix) {
      fix.textContent =
        answers.priorite ===
        'Simplicite'
          ? 'La solution : un extrait vieilli 24 mois, inodore, en abonnement, pour ne plus jamais avoir à y penser'
          : DEFAULT_FIX;
    }


    var tags =
      byId('vitResTags');

    if (tags) {
      var list = [
        'Inodore',
        'Vieilli 24 mois',
        'Cure de 90 jours'
      ];

      if (
        answers.priorite ===
        'Qualite de la formule'
      ) {
        list = [
          'Standardisé en SAC',
          'CoQ10 ubiquinol',
          'Inodore'
        ];
      }

      if (
        answers.priorite ===
        'Simplicite'
      ) {
        list = [
          'Inodore',
          'Abonnement',
          'Annulable à tout moment'
        ];
      }

      if (
        answers.priorite ===
        'Prix'
      ) {
        list = [
          'Meilleur prix au jour',
          'Cadeaux inclus',
          'Livraison offerte'
        ];
      }

      tags.textContent = '';

      list.forEach(
        function (text) {
          var tag =
            document.createElement(
              'span'
            );

          tag.className =
            'vit-quiz-tag';

          tag.textContent =
            text;

          tags.appendChild(tag);
        }
      );
    }


    /*
      Construction securisee :
      le prenom saisi ne devient jamais du HTML.
    */

    var nudge =
      byId('vitResNudge');

    if (
      nudge &&
      answers.firstName
    ) {
      nudge.textContent = '';

      nudge.appendChild(
        document.createTextNode(
          answers.firstName +
          ', vous préférez comprendre avant d’acheter ?'
        )
      );

      nudge.appendChild(
        document.createElement('br')
      );

      var link =
        document.createElement('a');

      link.href =
        URL_PRODUIT;

      link.textContent =
        'Tout est expliqué sur la page produit.';

      nudge.appendChild(link);
    }
  }


  /* =========================================================
     FORMULAIRE
     ========================================================= */

  if (form) {
    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();

        if (
          !form.checkValidity()
        ) {
          form.reportValidity();
          return;
        }

        var nameInput =
          byId('vitName');

        var emailInput =
          byId('vitEmail');

        var phoneInput =
          byId('vitPhone');

        var name =
          nameInput
            ? nameInput.value.trim()
            : '';

        var email =
          emailInput
            ? emailInput.value.trim()
            : '';

        var phone =
          phoneInput
            ? phoneInput.value.trim()
            : '';

        if (
          !name ||
          !email
        ) {
          return;
        }

        answers.firstName =
          name;

        answers.email =
          email;

        answers.phone =
          phone;

        score =
          computeScore();


        /* KLAVIYO */

        if (
          window.klaviyo &&
          typeof window.klaviyo.push ===
          'function'
        ) {
          window.klaviyo.push([
            'identify',
            {
              '$email':
                answers.email,

              '$first_name':
                answers.firstName,

              '$phone_number':
                answers.phone || '',

              'Quiz_Age':
                answers.age ||
                'Non renseigne',

              'Quiz_Experience':
                answers.experience ||
                'Non renseigne',

              'Quiz_Freins':
                answers.freins
                  ? answers.freins.join(', ')
                  : 'Aucun',

              'Quiz_Moment':
                answers.moment ||
                'Non renseigne',

              'Quiz_Duree_Cure':
                answers.duree ||
                'Non renseigne',

              'Quiz_Priorite':
                answers.priorite ||
                'Non renseigne',

              'Quiz_Score':
                score
            }
          ]);

          window.klaviyo.push([
            'track',
            'Quiz VITAE termine',
            {
              'Age':
                answers.age ||
                'Non renseigne',

              'Frein_principal':
                answers.freins
                  ? answers.freins[0]
                  : 'Aucun',

              'Score':
                score
            }
          ]);
        }

        personalize();

        next();

        startLoading();
      }
    );
  }


  /* =========================================================
     CHARGEMENT
     ========================================================= */

  var LOADING_MESSAGES = [
    {
      at: 0,
      title:
        'Nous préparons votre recommandation',
      subtitle:
        'Lecture de vos réponses...'
    },
    {
      at: .34,
      title:
        'Calcul de votre score',
      subtitle:
        'Analyse de vos cures précédentes...'
    },
    {
      at: .67,
      title:
        'Construction de votre cure',
      subtitle:
        'Sélection du format adapté...'
    }
  ];


  function startLoading() {
    var token =
      ++loadToken;

    var pct =
      byId('vitLoadPct');

    var title =
      byId('vitLoadTitle');

    var sub =
      byId('vitLoadSub');

    var ring =
      overlay.querySelector(
        '.vit-quiz-ring-fill'
      );

    var circumference =
      2 *
      Math.PI *
      22;

    if (ring) {
      ring.style.strokeDashoffset =
        circumference;
    }

    if (pct) {
      pct.textContent = '0%';
    }

    if (reducedMotion) {
      if (ring) {
        ring.style.strokeDashoffset =
          0;
      }

      if (pct) {
        pct.textContent =
          '100%';
      }

      if (title) {
        title.textContent =
          'Votre recommandation est prête';
      }

      if (sub) {
        sub.textContent =
          'Analyse terminée.';
      }

      setTimeout(
        function () {
          if (
            token === loadToken
          ) {
            next();
          }
        },
        150
      );

      return;
    }

    var start = null;
    var duration = 6000;
    var messageIndex = -1;


    function tick(time) {
      if (
        token !== loadToken
      ) {
        return;
      }

      if (!start) {
        start = time;
      }

      var progress =
        Math.min(
          (time - start) /
          duration,
          1
        );

      var eased =
        progress < .5
          ? 2 *
            progress *
            progress
          : -1 +
            (4 - 2 * progress) *
            progress;

      if (pct) {
        pct.textContent =
          Math.round(
            eased * 100
          ) + '%';
      }

      if (ring) {
        ring.style.strokeDashoffset =
          circumference -
          eased *
          circumference;
      }

      for (
        var i =
          LOADING_MESSAGES.length - 1;
        i >= 0;
        i--
      ) {
        if (
          progress >=
          LOADING_MESSAGES[i].at
        ) {
          if (
            messageIndex !== i
          ) {
            messageIndex = i;

            if (title) {
              title.textContent =
                LOADING_MESSAGES[i]
                  .title;
            }

            if (sub) {
              sub.textContent =
                LOADING_MESSAGES[i]
                  .subtitle;
            }
          }

          break;
        }
      }

      if (progress < 1) {
        requestAnimationFrame(
          tick
        );

      } else {
        setTimeout(
          function () {
            if (
              token === loadToken
            ) {
              next();
            }
          },
          120
        );
      }
    }

    requestAnimationFrame(tick);
  }


  /* =========================================================
     OUVERTURE
     ========================================================= */

  function openQuiz() {
    overlay.classList.add(
      'is-open'
    );

    overlay.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.style.overflow =
      'hidden';

    var header =
      document.querySelector(
        'header'
      );

    var footer =
      document.querySelector(
        'footer'
      );

    if (header) {
      header.style.display =
        'none';
    }

    if (footer) {
      footer.style.display =
        'none';
    }

    show(0);

    if (closeBtn) {
      requestAnimationFrame(
        function () {
          closeBtn.focus({
            preventScroll: true
          });
        }
      );
    }
  }


  /* =========================================================
     FERMETURE
     ========================================================= */

  function leaveQuiz() {
    window.location.href = '/';
  }


  if (closeBtn) {
    closeBtn.addEventListener(
      'click',
      leaveQuiz
    );
  }


  /* =========================================================
     CLAVIER
     ========================================================= */

  document.addEventListener(
    'keydown',
    function (event) {
      if (
        !overlay.classList.contains(
          'is-open'
        )
      ) {
        return;
      }

      if (
        event.key === 'Escape'
      ) {
        event.preventDefault();

        leaveQuiz();

        return;
      }

      if (
        event.key !== 'Tab'
      ) {
        return;
      }

      var all =
        overlay.querySelectorAll(
          'button:not([disabled]),' +
          'a[href],' +
          'input:not([disabled]),' +
          '[tabindex]:not([tabindex="-1"])'
        );

      var focusable =
        Array.prototype.filter.call(
          all,
          function (element) {
            return (
              element.getClientRects()
                .length > 0
            );
          }
        );

      if (!focusable.length) {
        return;
      }

      var first =
        focusable[0];

      var last =
        focusable[
          focusable.length - 1
        ];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();

      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    }
  );


  /* =========================================================
     PUBLIC
     ========================================================= */

  window.openVitaeQuiz =
    openQuiz;


  /* Ouvre automatiquement le quiz */

  openQuiz();

})();